import React from "react";
import { PrismicLink } from "@prismicio/react";
import { linkResolver } from "../prismic-configuration";
import { hasLink } from "../PrismicUtils";

type Props = {
    children:any;
    document?:any;
    href?:any;
}

const StandardLinkButton = ({children, document, href}:Props) => {
    const className = "flex items-center justify-center w-full h-full bg-gcc-bright-orange hover:bg-gcc-hover rounded-full text-center font-bold text-white";
    const documentLinkType = document?.link_type;

    if (href) {
        return (
            <PrismicLink className={className} href={href}>
                {children}
            </PrismicLink>
        );
    }
    if (hasLink(document))  {
        if (documentLinkType === 'Document') {
            const resolvedHref = linkResolver(document);

            return (
                <PrismicLink className={className} href={resolvedHref}>
                    {children}
                </PrismicLink>
            );
        }

        return (
            <PrismicLink className={className} field={document} linkResolver={linkResolver}>
                {children}
            </PrismicLink>
        );
    }
    return null;
};

export default StandardLinkButton;